<template>
  <nav class="navbar navbar-dark navbar-expand-lg bg-black px-5">
    <div class="container-fluid">
      <!-- Logo -->
      <a class="navbar-brand" href="/">
        <img class="img-fluid" width="150" src="/assets/theloungebar-logo.png" alt="Logo" />
      </a>

      <!-- Burger Icon for Mobile -->
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Desktop Menu -->
      <div class="collapse navbar-collapse" :class="{ show: isMenuOpen }" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item p-5">
            <router-link class="nav-link d-inline-block p-0 fs-17" to="/afterwork">Afterwork</router-link>
          </li>
          <li class="nav-item p-5 dropdown" @click="toggleDropdown">
            <a class="nav-link d-inline-block p-0 fs-17 dropdown-trigger" style="cursor:pointer;">
              Menyer
              <img :class="{ rotated: isDropdownOpen }" src="/assets/arrow-icon.svg" />
            </a>
            <div class="dropdown-content" v-show="isDropdownOpen">
              <router-link class="px-4 py-2 nav-link" to="/meny/matmeny">Matmeny</router-link>
              <router-link class="px-4 py-2 nav-link" to="/meny/drinklista">Drinklista</router-link>
            </div>
          </li>
          <li class="nav-item p-5">
            <router-link class="nav-link d-inline-block p-0 fs-17" to="/kontaktaoss">Kontakt</router-link>
          </li>
        </ul>
      </div>

      <!-- Mobile Menu -->
      <transition name="fade">
        <div
          v-if="isMenuOpen"
          @click.stop
          class="position-fixed top-0 w-100 bg-black text-white d-flex flex-column align-items-center pt-5 vh-100"
          style="left: 0;"
        >
          <!-- Close Button -->
          <button
            @click.stop="toggleMenu"
            aria-label="Close menu"
            class="btn-close btn-close-white position-absolute"
            style="top: 1rem; right: 1rem;"
          ></button>

          <!-- Navigation Links -->
          <ul class="nav flex-column text-center mt-4">
            <li class="nav-item mb-3">
              <router-link @click="toggleMenu" class="nav-link fs-4 text-white" to="/">
                Startsida
              </router-link>
            </li>
            <li class="nav-item mb-3">
              <router-link @click="toggleMenu" class="nav-link fs-4 text-white" to="/afterwork">
                Afterwork
              </router-link>
            </li>
            <li class="nav-item mb-3">
              <router-link @click="toggleMenu" class="nav-link fs-4 text-white" to="/meny/matmeny">
                Matmeny
              </router-link>
            </li>
            <li class="nav-item mb-3">
              <router-link @click="toggleMenu" class="nav-link fs-4 text-white" to="/meny/drinklista">
                Drinkmeny
              </router-link>
            </li>
            <li class="nav-item mb-3">
              <router-link @click="toggleMenu" class="nav-link fs-4 text-white" to="/kontaktaoss">
                Kontakt
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isDropdownOpen: false, // For dropdown menu
      isMenuOpen: false, // For mobile menu
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style scoped>

  /* Dropdown Styling */
  .dropdown-content {
    position: absolute;
    top: 100px;
    left: 0;
    background-color: rgba(0, 0, 0, 0.9);
    color: #fff;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    z-index: 9999;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }
  
  .dropdown-content.open {
    display: block;
  }
  
  /* Rotating Arrow */
  img.rotated {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }
/* Navbar Link Styling */
.nav-link {
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: #f5f5f5;
  text-decoration: none;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease-in-out;
}

.nav-link:hover {
  color: #937d51;
  transform: translateY(-2px);
  text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
}

/* Navbar Height */
.navbar {
  height: 60px;
  padding: 0.5rem 1rem;
}

/* Mobile Menu Styling */
.position-fixed {
  z-index: 1050;
}

.nav.flex-column .nav-link {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

/* Close Button Styling */
.btn-close {
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  z-index: 1051; /* Make sure it is above other elements */
}

.btn-close-white {
  filter: brightness(0) invert(1);
}

.btn-close::before,
.btn-close::after {
  content: '';
  position: absolute;
  width: 1.5rem;
  height: 0.2rem;
  background-color: currentColor;
  top: 50%;
  left: 50%;
  transform-origin: center;
}

.btn-close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.btn-close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
